import { render } from "./ContactsApp.vue?vue&type=template&id=778f038e"
import script from "./ContactsApp.vue?vue&type=script&lang=js"
export * from "./ContactsApp.vue?vue&type=script&lang=js"

import "./ContactsApp.vue?vue&type=style&index=0&id=778f038e&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__